module.exports = __webpack_public_path__ + "static/media/ticket_campaign_preview_instruction_title_pic.340b2aea.svg";